import { ReactComponent as Torch } from '../assets/torch.svg';

const MarqueeText = () => {
    return (
        <>
            <li>The First staked ETH NFT</li>
            <li><Torch /></li>
            <li>100% Community Aligned</li>
            <li><Torch /></li>
        </>
    )
}

export default MarqueeText;